import BreadCrumb from 'Components/Common/BreadCrumb'
import React from 'react'
import { Container } from 'reactstrap'
import PropertyStatusCard from './Components/PropertyWidgets';
import ManagePropertiesTable from './Components/ManagePropertiesTable';
import { useQuery } from '@tanstack/react-query';
import { propertiesWidgetsCount } from 'endpoints/properties/propertiesListings.action';

const Properties = () => {
    document.title = "Properties";

    const { data: propertyWidgetsData, isError, isPending } = useQuery({
        queryKey: ['property-widgets-count'],
        queryFn: () => propertiesWidgetsCount(),
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: true,
        retry: 3,
    });

    const dynamicPropertyWidgets = propertyWidgetsData?.data;

    const propertyStatusData = {
        icon: "bx bx-home",
        title: "Total Properties",
        total: dynamicPropertyWidgets?.totalProperties || 0,
        items: [
            { label: "Approved", value: dynamicPropertyWidgets?.approvedProperties || 0 },
            { label: "Pending", value: dynamicPropertyWidgets?.pendingProperties || 0 },
            { label: "Rejected", value: dynamicPropertyWidgets?.rejectedProperties || 0 },
            { label: "Awaiting Inspection", value: dynamicPropertyWidgets?.inspectionAwaiting || 0 },
        ],
    };

    const propertyDealsData = {
        icon: "bx bx-dollar",
        title: "Property Deals",
        total: dynamicPropertyWidgets?.totalDeal || 0,
        items: [
            { label: "Total Sold", value: dynamicPropertyWidgets?.totalSoldProperties || 0 },
            { label: "Total Rented", value: dynamicPropertyWidgets?.totalRentedProperties || 0 },
            { label: "Ongoing Deals", value: dynamicPropertyWidgets?.ongoingDeal || 0 },
        ],
    };

    // Show loading state
    if (isPending) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // Show error state  
    if (isError) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center">
                    <div className="text-danger mb-3">
                        <i className="ri-error-warning-line" style={{ fontSize: '3rem' }}></i>
                    </div>
                    <h5 className="text-danger">Failed to load builder data</h5>
                    <p className="text-muted">Please refresh the page to try again.</p>
                </div>
            </div>
        );
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb
                        title="Properties"
                        pageTitles={[
                            { label: "Dashboard", path: "/" },
                            { label: "Properties" }
                        ]}
                    />
                    <div className="d-flex flex-row w-100 gap-3">
                        <div className='w-50'><PropertyStatusCard
                            icon={propertyStatusData.icon}
                            title={propertyStatusData.title}
                            total={propertyStatusData.total}
                            items={propertyStatusData.items}
                        /></div>
                        <div className='w-50'><PropertyStatusCard
                            icon={propertyDealsData.icon}
                            title={propertyDealsData.title}
                            total={propertyDealsData.total}
                            items={propertyDealsData.items}
                        /></div>
                    </div>
                    <div>
                        <ManagePropertiesTable />
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Properties